var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.738,
    height: 16.739,
    viewBox: "0 0 16.738 16.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-add-team-member",
    d: "M15.9,7.532h-6.7V.837a.837.837,0,0,0-1.674,0v6.7H.837a.837.837,0,0,0,0,1.674h6.7v6.7a.837.837,0,1,0,1.674,0v-6.7h6.7a.837.837,0,1,0,0-1.674Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.54af1b76c481ec58eb879795e1efb159.svg";
export { ForwardRef as ReactComponent };